import React from "react";

const PlayIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="56"
      height="35"
      viewBox="0 0 56 35"
    >
      <g
        id="Group_1180"
        data-name="Group 1180"
        transform="translate(-493 -457)"
        opacity="0.63"
      >
        <rect
          id="Rectangle_3507"
          data-name="Rectangle 3507"
          width="56"
          height="35"
          rx="10"
          transform="translate(493 457)"
          fill="#fff"
        />
        <path
          id="Polygon_28"
          data-name="Polygon 28"
          d="M8,0l8,14H0Z"
          transform="translate(528 467) rotate(90)"
          fill="#484848"
        />
      </g>
    </svg>
  );
};

export default PlayIcon;
